// Module
var code = "<img id=\"logo\" ng-src=\"{{ model.logoSrc }}\"> <img id=\"ZBJ_logo\" ng-if=\"model.xAccountType == 'zbj'\" ng-src=\"{{ model.ZBJLogoSrc }}\"> <span id=\"backToHomepage\"> </span> <div id=\"firstLoginSwitchTip\" style=\"display:none\"> <span style=\"display:block;margin:10px\"></span> </div>";
// Exports
module.exports = code;


//////////////////
// WEBPACK FOOTER
// ./public/hws/js/notify/views/banner.html
// module id = 277
// module chunks = 0